module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0093.jpg?v=fac8359d";